/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEquipment } from 'app/shared/model/equipment.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';

export interface IDiaglabEquipment {
  id?: string;
  name?: string;
  aeTitle?: string;
  supended?: boolean | null;
  mfdDate?: number;
  dateSupended?: number | null;
  reasonSupended?: string | null;
  maintainanceCycle?: number | null;
  lastMaintenanceDate?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  mwl?: boolean;
  underMaintainance?: boolean | null;
  equipment?: IEquipment;
  diagLab?: IDiagLab;
}

export const defaultValue: Readonly<IDiaglabEquipment> = {
  supended: false,
  active: false,
  mwl: false,
  underMaintainance: false,
};
